"use strict";

exports.__esModule = true;
var _MetricQueryController = require("./MetricQueryController");
Object.keys(_MetricQueryController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MetricQueryController[key]) return;
  exports[key] = _MetricQueryController[key];
});